import { gql, useQuery } from '@apollo/client';

/**
 * Single-program query for the enrolled "Program inner" page.
 *
 * Like the old MFE's program page (frontend-app-dashboard), `programCourses`
 * only carries `openedxCourseId` here — the per-course display data (name,
 * image, links) comes from the learner-home-init endpoint, not a nested
 * GraphQL relationship. We intentionally do NOT fetch a course-overview
 * relationship: it isn't reliably exposed to the learner role.
 */
const GET_PROGRAM_BY_ID = gql`
  query FetchProgramById($id: Uuid!) {
    programs(where: { id: { _eq: $id } }) {
      id
      name
      description
      about
      image
      price
      duration
      durationMetric
      achievements
      programCourses {
        course {
          id
          openedxCourseId
        }
      }
    }
  }
`;

export const useProgramById = (id) => {
  const { data, loading, error } = useQuery(GET_PROGRAM_BY_ID, {
    variables: { id },
    skip: !id,
  });

  return {
    program: data?.programs?.[0] || null,
    loading,
    error,
  };
};
